const getRandom = (min = 10, max = 99999) => {
  return Math.floor(Math.random() * (max - min)) + min;
};

export const getCustomId = () => {
  return parseInt(new Date().getTime().toString().slice(-6) + getRandom());
};
